<script>
import baseMixin from '@/mixins/baseMixin'
import OverviewStatsDto from '@/models/overview/overviewStatsDto'
import { isNonEmptyArray } from '@/helpers/array-helpers'
import ClientGroupOverviewFillRateChart from '@/components/overview/client-group-overview-fill-rate-chart.vue'

export default {
  name: 'DashboardFillRateStats',
  components: { ClientGroupOverviewFillRateChart },
  mixins: [baseMixin],
  props: {
    stats: {
      type: OverviewStatsDto,
      default: new OverviewStatsDto(),
    },
  },
  computed: {
    hasOverviewData() {
      return isNonEmptyArray(this.overviewData)
    },
    calcTotalOpenBookings() {
      return this.stats.openBookings
    },
    compFilledBookings() {
      return this.stats.filled
    },
    compUnfilledBookings() {
      return this.stats.unfilled
    },
    compTotalBookings() {
      return this.stats.totalBookings
    },
  },
}
</script>

<template>
  <div class="d-flex justify-end align-center">
    <div class="text-center">
      <header class="caption">
        {{ $t('clientGroupOverview.stats.totalFilledLabel') }}
      </header>

      <p class="text-h4 mb-0 text-center">{{ compFilledBookings }}</p>
    </div>

    <div class="text-center ml-8">
      <header class="caption">
        {{ $t('clientGroupOverview.stats.totalOpenLabel') }}
      </header>

      <p class="text-h4 mb-0 text-center">{{ compUnfilledBookings }}</p>
    </div>

    <div class="text-center ml-8">
      <header class="caption">
        {{ $t('clientGroupOverview.stats.totalBookingsLabel') }}
      </header>

      <h4 class="text-h4 mb-0">{{ compTotalBookings }}</h4>
    </div>

    <ClientGroupOverviewFillRateChart
      class="ml-6 mt-4"
      :overview-stats="stats"
      :width="90"
      :height="90"
      :cut-out="35"
    />
  </div>
</template>
